import {useIntl} from 'react-intl'
import dataAxios from '../../../modules/auth/core/dataAxios'
import {useQueryRequest} from '../../user-management/users-list/core/QueryRequestProvider'
import {buildUserApiQuery} from '../../user-management/users-list/core/userListQuery'

const API_URL = process.env.REACT_APP_API_URL || ''

const apiBase = () => (API_URL || '').replace(/\/api\/?$/i, '')

type Props = {
  filters: {page: number; size: number; status: string; role: string}
}

export const ClientsListToolbar = ({filters}: Props) => {
  const intl = useIntl()
  const {state} = useQueryRequest()

  const runExport = async (exportAs: 'excel' | 'csv') => {
    try {
      const exportParams = buildUserApiQuery(state, {
        listScope: 'clients',
        ...(state.search ? {searchUser: state.search} : {}),
        ...(filters.status ? {status: filters.status} : {}),
      })
      const res = await dataAxios.get(`${API_URL.replace(/\/$/, '')}/export`, {
        params: {dataType: 'users', exportAs, ...exportParams},
      })
      const raw = res.data?.data?.url as string | undefined
      if (!raw) return
      const rel = raw.replace(/^\.\//, '')
      window.open(`${apiBase()}/${rel}`, '_blank', 'noopener,noreferrer')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='d-flex flex-wrap gap-2 justify-content-end'>
      <button type='button' className='btn btn-light-primary btn-sm' onClick={() => runExport('csv')}>
        {intl.formatMessage({id: 'USERS.EXPORT.CSV'})}
      </button>
      <button type='button' className='btn btn-light-primary btn-sm' onClick={() => runExport('excel')}>
        {intl.formatMessage({id: 'USERS.EXPORT.EXCEL'})}
      </button>
    </div>
  )
}
